<template>
  <div class="bd-y-black p-y-3">
    <div class="container h6 c-gray60">
      <p>You can manage your service requests or change your account
      information by creating a password to access your Accounts and Requests.
      </p>
      <router-link
          :to="{ name: 'tos-password'}"
          tag="button"
          class="btn btn-large text-bold m-y-1 w-100:mo"
          selenium="dashboard-button">
        Create My Account
      </router-link>
      <p>Questions about your request? Call <span class="c-black">1-855-723-2266</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'manage-request-tos',
};
</script>
